const fonts = {
  selfModern: "font-family: 'Self Modern', Georgia, serif;",
  helveticaNeue: "font-family: 'Helvetica Neue', Arial, sans-serif;",
  helveticaNeueLight: "font-family: 'Helvetica Neue Light', Arial, sans-serif;",
  helveticaNeueMedium:
    "font-family: 'Helvetica Neue Medium', Arial, sans-serif;",
  helveticaNeueCondensedBold:
    "font-family: 'Helvetica Neue Condensed Bold', Arial, sans-serif;",
  helveticaNeueCondensedMedium:
    "font-family: 'Helvetica Neue Condensed Medium', Arial, sans-serif;",
  moretBold: "font-family: moret, serif;font-weight: 700;",
  moretLight: "font-family: moret, serif;font-weight: 300;",
  openSans: "font-family : 'Open Sans', sans-serif;",
  ivyStyleLight: "font-family: 'ivystyle-sans', sans-serif; font-weight: 300;",
  ivyStyleRegular:
    "font-family: 'ivystyle-sans', sans-serif; font-weight: 400;",
  ivyPrestoLight:
    "font-family: 'ivypresto-display', serif;font-weight: 300;font-style: normal;",
  ivyJournalThin:
    "font-family: 'ivyjournal', sans-serif;font-weight: 200;font-style: normal;",
  americana: "font-family: 'Americana', sans-serif; font-weight: 400;",
  americanaItalic: "font-family: 'Americana Italic', sans-serif; font-weight: 400;",
  americanaRoman: "font-family: 'Americana Roman', sans-serif; font-weight: 400;",
  ttNormsProBold: "font-family: 'TTNormsPro Bold'; font-weight: 700;",
  ttNormsProRegular: "font-family: 'TTNormsPro Regular'; font-weight: 400;",
  americanaBTbold: "font-family: 'Americana BT'; font-style: bold;",
  americanaBTroman: "font-family: 'Americana BT'; font-style: roman;",
  TTNormsPro:  "font-family: 'TTNormsPro Bold'; font-weight: 700;"
}

export default fonts
